"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Plus = function Plus(props) {
  var _props$height = props.height,
      height = _props$height === void 0 ? 12 : _props$height,
      _props$width = props.width,
      width = _props$width === void 0 ? 12 : _props$width,
      _props$color = props.color,
      color = _props$color === void 0 ? "#7F7F7F" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 12 12",
    scale: width / 12,
    width: width,
    height: width,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    width: width,
    height: width,
    fill: color,
    d: "M7.2 4.8H12v2.4H7.2V12H4.8V7.2H0V4.8h4.8V0h2.4v4.8z",
    id: "Plus"
  }));
};

var _default = Plus;
exports["default"] = _default;
module.exports = exports["default"];